export const REQUEST_AVAILABLE_ADDONS = 'REQUEST_AVAILABLE_ADDONS';
export const RECEIVE_AVAILABLE_ADDONS = 'RECEIVE_AVAILABLE_ADDONS';
export const SET_AVAILABLE_ADDONS_FAILURE = 'SET_AVAILABLE_ADDONS_FAILURE';
export const CLEAR_AVAILABLE_ADDONS_ERROR_MESSAGE = 'CLEAR_AVAILABLE_ADDONS_ERROR_MESSAGE';
export const ON_SAVE_DINING = 'ON_SAVE_DINING';
